import { render, staticRenderFns } from "./UnsavedModal.vue?vue&type=template&id=14d0f7ae&scoped=true"
import script from "./UnsavedModal.vue?vue&type=script&lang=js"
export * from "./UnsavedModal.vue?vue&type=script&lang=js"
import style0 from "./UnsavedModal.vue?vue&type=style&index=0&id=14d0f7ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d0f7ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14d0f7ae')) {
      api.createRecord('14d0f7ae', component.options)
    } else {
      api.reload('14d0f7ae', component.options)
    }
    module.hot.accept("./UnsavedModal.vue?vue&type=template&id=14d0f7ae&scoped=true", function () {
      api.rerender('14d0f7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/UnsavedModal.vue"
export default component.exports